import React from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import FaqMarketToggle from "@/components/FaqMarketToggle";

export default function FAQ() {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const market = params.get("country") === "fr" ? "fr" : "nl";
  const ns = market === "fr" ? "faq_page_fr" : "faq_page";
  const groups = t(`${ns}.groups`, { returnObjects: true }) || [];
  const setMarket = (m) => setParams(m === "fr" ? { country: "fr" } : {}, { replace: true });

  let counter = 0;
  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-16 md:py-24" data-testid={`faq-page-${market}`}>
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#5BA83F]">{t(`${ns}.eyebrow`)}</p>
      <h1 className="font-heading text-4xl md:text-5xl font-extrabold text-[#1B3A6B] mt-3 tracking-tight">{t(`${ns}.title`)}</h1>
      <p className="mt-4 text-slate-600 leading-relaxed max-w-2xl">{t(`${ns}.intro`)}</p>
      <div className="mt-6"><FaqMarketToggle t={t} value={market} onChange={setMarket} testid="faq-page-market" /></div>

      {groups.map((group, gi) => (
        <section key={`${market}-${gi}`} className="mt-12">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-[#0F172A] mb-4 pl-3 border-l-4 border-[#5BA83F]">
            {group.category}
          </h2>
          <Accordion type="single" collapsible>
            {group.items.map((f, i) => {
              const id = counter++;
              return (
                <AccordionItem key={i} value={`f-${gi}-${i}`}>
                  <AccordionTrigger data-testid={`faq-q-${id}`} className="text-left">{f.q}</AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed">{f.a}</AccordionContent>
                </AccordionItem>
              );
            })}
          </Accordion>
        </section>
      ))}
    </div>
  );
}
